module.exports = new __parcel__URL__("ContentWrapperSpotlightGIF-dark.bbe9839d.gif").toString();